/**
 * External Dependencies
 */

import './components/nav';
import './components/anim';
import './components/accordion';
import './components/carousel';
import './components/filter-news';
import './components/filter-mixer-manuals';
import './components/filter-training-videos';
import './components/build-my-mixer';
import LazyLoad from "vanilla-lazyload";
import './components/modal';
import './components/region_select';
import 'lite-youtube-embed';
import './components/searchbar';
import 'instagram-feed';
import './components/gclid';


// One offs
// Lazyload images
var myLazyLoad = new LazyLoad();
